<template>
  <div class="my-modal-overlay"
    :class="[show ? 'opened-dialog' : 'closed-dialog']">
    <div class="dialog-container">
      <v-card flat id="actions-card" class="my-card">
        <v-row>
          <v-col class="d-flex align-center" cols md="2">
            <div class="inspections-title-icon">
              <v-img
                contain
                height="24"
                width="24"
                class=""
                src="@/assets/lightning.svg"
              ></v-img>
            </div>
            <div>
              <h2>{{$t("actions")}}</h2>
            </div>
          </v-col>
          <v-col md="2" lg="4" class="hidden-sm-and-down"></v-col>

          <v-col class="d-none d-sm-block d-md-none"></v-col>
          <v-col cols="12" sm="8" md="4" lg="3">
            <date-picker
              v-model="actionDate"
              :placeholder="$t('selectDate')"
              value-type="date"
              format="MMMM D, YYYY"
              :clearable="false"
              class="datepicker-container"
              popup-class="my-datepicker-popup"
              input-class="datepicker-btn datepicker-btn-sm"
              :lang="lang"
            >
              <template v-slot:icon-calendar>
                <v-img src="@/assets/calendar.svg"></v-img>
              </template>
            </date-picker>
          </v-col>
          <v-col class="d-none d-sm-block"></v-col>
        </v-row>

        <div class="selected-hives-label">
          <v-icon class="mr-2" color="#000000de">mdi-archive-outline</v-icon>
          {{$t("selected_hives")}}
          <span class="pl-2 pl-sm-4 pl-md-8">{{selectedHives.length}}</span>
        </div>

        <v-tabs
          grow
          hide-slider
          class="inspections-tabs"
          background-color="#F7F7FC"
          color="#262338"
          v-model="activeTab"
        >
          <v-tab v-for="(tab, index) in actionsModalTabs" :key="index"
            class="my-tab"
            :class="{'active-tab': tab.active}"
            @change="updateTab(index)"
          >
            <v-img
              v-if="tab.active"
              contain
              height="24"
              width="24"
              class="tab-icon"
              :src="`${publicPath}img/icons/`+tab.icon+'_active.svg'"
            ></v-img>
            <v-img
              v-else
              contain
              height="24"
              width="24"
              class="tab-icon"
              :src="`${publicPath}img/icons/`+tab.icon+'_inactive.svg'"
            ></v-img>
            {{$t(tab.name)}}
          </v-tab>
          <v-tabs-items v-model="activeTab" touchless>
            <v-tab-item
              v-for="(tab, index) in actionsModalTabs"
              :key="index"
            >
              <component v-bind:is="tab.component"></component>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>

        <v-card-actions class="my-card-actions inspections-actions">
          <v-row>
            <v-col md="5" lg="6" xl="7" class="d-none d-sm-none d-md-block"></v-col>
            <v-col cols="12" sm>
              <v-btn
                height="54px"
                outlined
                block
                class="my-btn red-btn"
                @click="cancelBtnAction"
              >
                {{$t("cancel")}}
                <v-spacer></v-spacer>
                <v-icon>mdi-close</v-icon>
              </v-btn>
            </v-col>
            <v-col cols="12" sm>
              <v-btn
                height="54px"
                depressed
                block
                dark
                @click.stop="saveBtnAction"
                class="my-btn save-btn"
                :disabled="!isValidAction"
              >
                {{$t("save")}}
                <v-spacer></v-spacer>
                <v-icon>{{check_icon}}</v-icon>
              </v-btn>
            </v-col>
          </v-row>
        </v-card-actions>
      </v-card>
    </div>
  </div>
</template>

<script>
  import ActionsHivesTab from '@/components/Actions/ActionsHivesTab';
  import ActionsTaskTab from '@/components/Actions/ActionsTaskTab';
  import {mapGetters, mapActions} from 'vuex';

  import moment from "moment";
  import DatePicker from 'vue2-datepicker';
  import 'vue2-datepicker/locale/el';
  import 'vue2-datepicker/locale/en';
  import 'vue2-datepicker/locale/es';
  import 'vue2-datepicker/index.css';

  export default {
    name: 'ActionsModal',
    components: {
      'hives-tab': ActionsHivesTab,
      'task-tab': ActionsTaskTab,
      DatePicker
    },
    props: {
     visible: Boolean
    },
    computed: {
      ...mapGetters([
        "selectedHives",
        "actionsModalTabs",
        "newActionData"
      ]),
      show: {
        get () {
          return this.visible
        },
        set (value) {
           if (!value) {
            this.$emit('close');
          }
        }
      },
      lang: {
        get() {
          return this.$i18n.locale;
        }
      },
      actionDate: {
        get () {
          return this.$store.state.actions.newActionData.initiated_at;
        },
        set(value) {
          this.$store.commit('setNewActionProp', {prop: 'initiated_at', value: value});
        }
      },
      isValidAction() {
        let validationProps = ['initiated_at', 'title'];
        let isHiveSelected = this.selectedHives.length != 0;
        let isValid = true;

        for (let k = 0; k < validationProps.length; k++) {
          let prop = validationProps[k];
          if (this.newActionData[prop] != undefined) {
            if (this.newActionData[prop] === '') {
              isValid = false;
            }
          } else {
            isValid = false;
          }
        }
        return isValid && isHiveSelected;
      }
    },
    data: () => ({
      publicPath: process.env.BASE_URL,
      activeTab: 0,
      check_icon: "$vuetify.icons.check_icon",
    }),
    methods: {
      ...mapActions(["setActiveTab", "setNewActionProp"]),
      updateTab(index) {
        this.activeTab = index;
        this.setActiveTab(index);
      },
      cancelBtnAction() {
        this.activeTab = 0;
        this.$emit('close');
      },
      saveBtnAction() {
        this.activeTab = 0;
        this.$emit('save');
      }
    }
  }
</script>

<style type="text/css">
  #actions-card {
    position: relative;
  }

  @media screen and (max-width: 960px) {
    #actions-card.my-card {
      padding: 35px 25px;
    }
  }

  @media screen and (max-width: 600px) {
    #actions-card.my-card {
      padding: 35px 25px 70px;
    }
  }
</style>
